
import a1residential from '../assets/a1residential.png'
import prontocasecase from "../assets/pronto.png"
import waa from "../assets/waa.png"
import crm from "../assets/crm.png"
import PathFinder from "../assets/geo-location.png"
import Profile_Photo from "../assets/Raju_Profile_photo.gif"
import heroBg from "../assets/webdev.svg";
import cloud from "../assets/cloudBg.png";
import cloudDark from "../assets/cloudDark.png";
import iKidz from "../assets/ikidz.png";
import relaxNow from "../assets/relax-now.png"
import  pisteyo from "../assets/pisteyo.jpeg"
import monday from "../assets/monday.jpeg"
import ga from "../assets/ga.jpg"
import lovelife from "../assets/lovelife.jpg"
import sportsjournal from "../assets/sportsjournal.jpeg"
import TrendingNow from "../assets/TrendingNow.jpg"
import talktoenergy from "../assets/talktoenergy.jpeg"
import highcourt from "../assets/highcourt.jpeg"
import reliefhub from "../assets/reliefhub.jpg";
import hcba from "../assets/hcba.jpeg"
import skin_care from "../assets/skin-care-app.jpeg"
import swing from "../assets/swing-user.png"
import swingAdmin from "../assets/swing-admin.png"
import GaAdmin from "../assets/ga-admin.jpeg"
import WhatKeyAdmin from "../assets/what-key-admin.jpeg"
import ikidzschool from "../assets/ikidzschool.png";
import ikidz_smart_app from "../assets/ikidz_smart_app.jpg";
import hcba_app from "../assets/hcba_app.jpg";
import hcbaadvocate from "../assets/hcbaadvocate.png";
import rewind from "../assets/rewind.jpg";

import { calculateAgeInYears } from '../utills/calculateAgeInYears'
import { dob } from './common'

const shortIntro = `हम एगो फ्रंट-एंड / फुल-स्टैक डेवलपर हईं. एह घरी हम 
  एनिक्स इन्वेंटिव प्राइवेट लिमिटेड में फुल-स्टैक डेवलपर के रूप में काम कर रहल बानी।`

const techStack = [
  {
    name: "जावास्क्रिप्ट के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  
  {
    name: "टाइपस्क्रिप्ट के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    source:"https://www.typescriptlang.org/docs/",
  },
  {
    name: "जेएस के रिएक्ट करीं",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    source:"https://legacy.reactjs.org/docs/getting-started.html",

  },
  {
    name: "कोणीय जे एस के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
    source:"https://angular.dev/overview",

  },  
  {
    name: "अगिला जेस के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original-wordmark.svg",
    source:"https://nextjs.org/docs",
  },
  {
    name: "जड़ता जेएस के बा",
    link: "https://avatars.githubusercontent.com/u/47703742?s=100&v=4",
    source:"https://inertiajs.com/"
  },
  {
    name: "रेडक्स के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    source:"https://handsonreact.com/docs/redux-thunk"
  },
  {
    name: "बूटस्ट्रैप के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
    source:"https://getbootstrap.com/docs/4.1/getting-started/introduction/"
  },
  {
    name: "सास के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg",
    source:"https://sass-lang.com/documentation/"
  }, 
  {
    name: "टेलविंड सीएसएस के बा",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
    source:"https://tailwindcss.com/docs/installation/framework-guides"
  },
  {
    name: "सामग्री उआई के बा",
    link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5nXwOB0nj3JI6mxepmQT1QC7hucMd9Fx1ig&s",
    source:"https://mui.com/material-ui/"
  },
  {
    name: "नोडजेएस के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    source:"https://www.w3schools.com/nodejs/default.asp"
  },
  {
    name: "एक्सप्रेस जेएस के बा",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
    source:"https://devdocs.io/express/"
  },
  {
    name: "नेस्टजेएस के बा",
    link: "https://docs.nestjs.com/assets/logo-small-gradient.svg",
    source: "https://docs.nestjs.com/"
  },
  {
    name: "मोंगो डीबी के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
    source:"https://www.mongodb.com/docs/atlas/getting-started/"
  },
  {
    name: "माईएसक्यूएल के बा",
    link: "https://w7.pngwing.com/pngs/962/92/png-transparent-database-mysql-backup-linux-command-line-interface-database-symbol-blue-commandline-interface-electric-blue-thumbnail.png",
    source:"https://dev.mysql.com/doc/"
  },
  {
    name: "डाकिया के काम करेला",
    link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    source:"https://learning.postman.com/docs/introduction/overview/"
  },
  {
    name: "डार्ट के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
    source:"https://dart.dev/language"
  },
  {
    name: "फड़फड़ात बा    ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg",
    source:"https://docs.flutter.dev/get-started/learn-flutter"
  },
  {
    name: "रिएक्ट नेटिव के बा",
    link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png",
    source:"https://reactnative.dev/docs/getting-started"
  },
  {
    name: "एचटीएमएल के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/HTML"
  },
  {
    name: "सीएसएस के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/CSS"
  },
  {
    name: "हेरोकू के नाम से जानल जाला",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg",
    source:"https://devcenter.heroku.com/articles/getting-started-with-nodejs"
  },
  {
    name: "गिट के बा",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    source:"https://git-scm.com/docs"
  },
  // {
  //   name: "C Language",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg",
  // },
  {
    name: "सी++ के बा",
    link: "https://w7.pngwing.com/pngs/579/803/png-transparent-the-c-programming-language-programmer-computer-programming-programming-blue-logo-computer-program-thumbnail.png",
    source:"https://www.w3schools.com/cpp/"
  },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },
  // { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  {
    name: "फायरबेस के बा",
    link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
    source:"https://firebase.google.com/docs"
  },
];

const contactLinks = [
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/29159rajusingh/",
  },
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/rajusingh99",
  },
  {
    name: "Leetcode",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-level-up-your-coding-skills-and-quickly-land-a-job-logo-color-tal-revivo.png",
    link: "https://leetcode.com/u/RajusinghofficialIND/",
  },
  {
    name: "Stack Overflow",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png",
    link: "https://stackoverflow.com/users/19923888/raju-kumar",
  },
  {
    name: "Instagram",
    url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
    link: "https://www.instagram.com/mr_singh_raju_/",
  },
  {
    name: "Youtube",
    url: "https://img.icons8.com/?size=50&id=85162&format=png&color=000000",
    link: "",
    // link: "https://www.youtube.com/@Coverage_Blogs",
  },
  {
    name: "X",
    url: "https://img.icons8.com/?size=50&id=13963&format=png&color=000000",
    link: "https://x.com/RajuSingh_159",
  },
];

 const serviceData = [
  {
    name: "Front-End Development",
    desc: `वेब डिजाइन में वेबसाइट सभ के निर्माण आ रखरखाव में कई अलग-अलग कौशल आ
     बिसय सभ के सामिल कइल जाला। हम वेब डिजाइन, यूजर इंटरफेस डिजाइन, रिस्पांसिव 
     डेवलपमेंट, स्टैंडर्ड-कम्प्लाएंट कोड, यूजर एक्सपीरियंस (यूएक्स) डिजाइन, आ एसईओ-फ्रेंडली
      डेवलपमेंट पर ध्यान दिहनी. ई तरीका निर्बाध आ आकर्षक उपयोगकर्ता अनुभव देके राउर 
      ब्रांड के बढ़ावेला।`,
    img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
  },
  {
    name: "Back End Development",
    desc: `बैक एंड डेवलपमेंट कवनो भी मजबूत आ स्केल करे लायक वेब एप्लीकेशन के रीढ़ हवे।
     हमार विशेषज्ञता सर्वर साइड लॉजिक, डेटाबेस मैनेजमेंट, आ एपीआई इंटीग्रेशन के निर्माण आ 
     रखरखाव में बा जवन डायनामिक आ हाई परफॉर्मेंस वेबसाइटन के पावर देला. हम सर्वर-साइड 
     डेवलपमेंट, डाटाबेस मैनेजमेंट, एपीआई डेवलपमेंट एंड इंटीग्रेशन सुरक्षा आ प्रमाणीकरण,
      स्केलेबिलिटी आ परफॉर्मेंस ऑप्टिमाइजेशन, मेंटेनेंस आ सपोर्ट पर ध्यान देत बानी.`,
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
  },
  {
    name: "Mobile Application Development",
    desc: `हमनी के एंड्रॉयड प्लेटफार्म पर कस्टम मोबाइल डेवलपमेंट, क्रॉस-प्लेटफॉर्म ऐप बनावल, 
    यूजर एक्सपीरियंस डिजाइन कइल आ चैटबॉट आ आवाज से नियंत्रित फीचर जइसन अभिनव
     मोबाइल इंटरफेस के एकीकरण समेत कई गो मोबाइल एप्लीकेशन डेवलपमेंट सेवा देत बानी 
     जा, जेहसे कि आधुनिक आ इंटरैक्टिव अनुभव उपलब्ध करावल जा सके. बहुमुखी ऐप बनावल
     जवन एंड्रॉयड अवुरी आईओएस दुनो प्लेटफॉर्म प बिना कवनो परेशानी के काम करेला, 
     जवना से आपके दर्शक के व्यापक पहुंच सुनिश्चित होई।`,
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
  },

];

const about = (
        <>
          हम एगो सॉफ्टवेयर डेवलपर हईं जेकरा लगे {<b>{calculateAgeInYears(dob)} साल</b>}  के अनुभव बा आ प्रोजेक्ट के
           कॉन्सेप्ट से लेके पूरा होखे तक ले जाए के मजबूत ट्रैक रिकॉर्ड बा। हम वायरफ्रेम 
           आ डिजाइन अवधारणा के उच्च प्रदर्शन वाला सॉफ्टवेयर एप्लीकेशन में बदले में
           माहिर बानी, साफ, दोबारा इस्तेमाल करे लायक, आ कुशल कोड के माध्यम से 
           उपयोगकर्ता के निर्बाध अनुभव सुनिश्चित करेनी। हमार जुनून डिजाइन, तकनीक, 
           आ नवाचार के मिलावे में बा, हर प्रोजेक्ट के शुरुआती विचार से लेके अंतिम रिलीज
            तक के मार्गदर्शन करे में बा। हमरा फ्रंटएंड आ बैकएंड दुनु के मजबूत जानकारी बा.
             फिलहाल हम बैकएंड डेवलपमेंट प ध्यान देले बानी, अपना काम के तकनीकी आधार
           के चलावत बानी।
        </>
        )

const detailAbout = (
  <>
    हम <strong>टंडसपुर, सीतामढ़ी, बिहार</strong> के रहवइया बानी। 
    हम <strong>चंडीगढ़</strong> आ <strong>मोहाली</strong> में अनुभव वाला 
    एक <strong>जोशीला सॉफ्टवेयर इंजीनियर</strong> बानी।{" "}
    <span>
      बहुत लोग हमके <strong>"राजू सिंह बिहार"</strong> भा 
      <strong>"भारतीय सॉफ्टवेयर इंजीनियर"</strong> के नाम से जानेला।
    </span>
  </>
);

const technologies_tools =(<>
      अत्याधुनिक तकनीक आ भरोसेमंद ओपन सोर्स सॉफ्टवेयर के संयोजन के इस्तेमाल करत हम 
      <b> स्मार्टफोन, टैबलेट, लैपटॉप आ डेस्कटॉप</b> खातिर यूजर फोकस, परफॉर्मेंस ऐप आ वेबसाइट बनावेनी.
</>) 


const projects = [
  // webs
  {
    src: a1residential,
    type:"web",
    // link:"https://a1residentialbuilders.com/",
    link:"https://www.a1-builders.com/",
    name:"A1आवासीयबिल्डर्स",
    figma:"https://www.figma.com/design/r5BUGIFP1Kzw2tvAEI3iv1/Untitled?node-id=0-1&p=f",
    adminFigma:"https://www.figma.com/design/g5AY22eZS5zAaIIFSFlUpG/A1---Admin?node-id=0-1&p=f",
    isSecure:false,
    description:`घर के आकार चाहे जवन होखे, ओकरा के रखरखाव कईल एगो संघर्ष हो
     सकता। हालांकि रउरा लगे अपना टू-डू लिस्ट में मौजूद हर चीज के पूरा करे के समय 
     भा औजार ना हो सकेला, जवन रउरा लगे बा ऊ बा एगो स्थानीय बाउर एक्स® जवना 
     में विशेषज्ञन के एगो भरोसेमंद टीम बा जवन डन राइट गारंटी के साथ हैंडसम सेवा 
     देत बा. भोजपुरी में अनुवाद कइल जाव`
  },
  {
    src: prontocasecase,
    link:"https://prontocasecash.com/",
    name:"प्रोन्टो केस कैश",
    figma:"https://www.figma.com/design/nWX94AvnPPq8B6w4Y1mQtl/Law-firm-Probationary-Period?node-id=0-1&p=f",
    isSecure:false,
    type:"web",
    description:`क्या आप किसी वाहन या संपत्ति दुर्घटना जैसे फिसलने और गिरने से घायल हुए हैं? 
    क्या आपका कोई मामला लंबित है लेकिन आपको अभी पैसे की ज़रूरत है? हम हर दिन आप जैसे 
    लोगों की मदद करते हैं जो अपने मुकदमे के निपटारे के लिए एक और साल इंतज़ार नहीं कर सकते।
    हमारी आवेदन प्रक्रिया में 3 मिनट से भी कम समय लगता है और अक्सर हम उसी दिन आपके लिए 
    जवाब दे सकते हैं। अगर आपको हमारी मदद की ज़रूरत है, तो कृपया नीचे अपना केस सबमिट करें 
    बटन पर क्लिक करें ताकि हम आपकी मदद कर सकें।`
  },
  {
    src: waa,
    link:"https://weareappointments.com/",
    name:"हम नियुक्तियां हैं",
    type:"web",
    figma:null,
    isSecure:false,
    description:`WeAreAppointments के निर्माण एजेंट लोग खातिर सरासर जरूरत के चलते 
    कईले रहे। लीड, गैर-विशेष अपॉइंटमेंट, वेबिनार रजिस्ट्रार आदि खरीद के नया संभावना से मिले
    के थकाऊ प्रयास के बाद हमनी के उपभोक्ता के सामने आवे के सबसे बढ़िया तरीका विकसित
    करे के फैसला कईनी जा...वर्चुअल अवुरी प्री-सेट अपॉइंटमेंट बना के। जवना आदमी के 
    मदद के जरूरत बा ओकरा संगे आपके कैलेंडर प विशेष अपॉइंटमेंट देखाई देवे से बढ़िया
    का हो सकता? विकास आ साझा ज्ञान में अनगिनत घंटा बीतल बा जवना से हमनी के
    अपना सिस्टम के रउरा अँगुरी के नोक पर ले आवे में सक्षम बानी जा. रउरा सभे 
    के शुभकामना आ निरंतर सफलता के कामना करत!`
  },
  {
    src: crm,
    link:"https://drive.google.com/drive/folders/1sHENXJl4yReoVktjcp1u3kxXDs2VuDIs?usp=sharing",
    name:"कर्मचारी प्रबंधन",
    type:"web",
    figma:null,
    isSecure:false,
    description:`कर्मचारी प्रबंधन संगठन के समग्र मिशन आ लक्ष्य के हासिल करे खातिर कर्मचारी
     लोग के आपन सर्वश्रेष्ठ प्रदर्शन करे में मदद करे के काम हवे। एहमें कर्मचारी के काम पर राखे 
     से ले के समाप्ति तक के पूरा सफर शामिल बा. हालांकि एकर कवनो सार्वभौमिक फार्मूला नइखे,
    प्रभावी कर्मचारी प्रबंधन खातिर कर्मचारी लोग के कार्यकाल में संबंध बनावे के जरूरत बा| एकरा
    खातिर ओह लोग के काम के निगरानी आ माप के भी जरूरत बा जवन कि ओह लोग के
    प्रोफेशनल लक्ष्य के संबंध में होखे। कर्मचारी के कारगर प्रबंधन अक्सर अलग-अलग प्रबंधक
    आ ओह लोग के रिपोर्ट के साथ प्रेरित करे, संवाद करे आ बिस्वास पैदा करे के क्षमता 
    पर निर्भर करे ला। बेहतरीन प्रबंधक अपना कर्मचारियन खातिर कोच के काम करेलें, अब
    जवन बढ़िया काम कर रहल बाड़े ओकरा के पहचानत रहेलें आ साथही ओह लोग के 
    सुधारे के चुनौती देत ​​बाड़े. जबकि कई गो काम आ कर्तव्य बाड़ें जे कर्मचारी प्रबंधन के
    तहत आवे लें, लगभग सभ पाँच श्रेणी में से कौनों एक में फिट हो सके लें।`
  },
  {
    src: TrendingNow,
    link:"",
    name:"अभी का रुझान",
    type:"web",
    figma:"https://www.figma.com/design/shmxWL5FKRO5GNOPPopBg6/PLAY",
    isSecure:false,
    description:`अंतिम गेमिंग अनुभव खातिर तइयार रहीं, जहाँ एक्शन, रोमांच, आ मनोरंजन के
     टक्कर होला! चाहे रउआ आकस्मिक खिलाड़ी होखीं भा कट्टर ईस्पोर्ट्स प्रशंसक, हमनी के रउआ
      के महाकाव्य गेमप्ले, प्रो टिप्स, नवीनतम गेमिंग खबर, आ तीव्र मल्टीप्लेयर लड़ाई से ढंकले 
      बानी जा। हमनी के समुदाय से जुड़ीं, आपन कौशल के स्तर बढ़ाईं, आ गेमिंग के दुनिया में 
      आगे रहीं!... नॉन स्टॉप गेमिंग सामग्री खातिर LIKE, SHARE & SUBSCRIBE मारीं! 
      🔔 अपडेट खातिर जुडल रहीं! 🚀 #PLAY # गेमिंगसमुदाय # गेमऑन # लेवलअप
      `
  },
  {
    src: iKidz,
    link:"https://ikidzschools.com/",
    name:"भारत का पहला तकनीक-सक्षम प्रीस्कूल",
    type:"web",
    figma:null,
    isSecure:false,
    description:`भारत के पहिला आ एकमात्र प्रीस्कूल जवन हमनी के आपन इन हाउस विकसित 
    ऐप के साथ प्रीस्कूल में ऑगमेंटेड रियलिटी के शामिल कइले बा, आईकिड्स सीखला के एगो 
    नया अर्थ देला। एह में मजेदार सीखन मॉड्यूल शामिल बा जवन लइकन के अक्षर, संख्या, 
    आकृति, मौसम के संख्या आ अउरी कई गो सीखला में मदद करेला। ई सब एगो नया 
    तरीका के माध्यम से जवन भारत के कवनो दोसर प्लेस्कूल ना कर सकेला। सभ आईकिड्स
     स्कूल में ऑगमेंटेड रियलिटी सक्षम फ्लैश कार्ड अवुरी टैबलेट दिहल गईल बा।`
  },
  {
    src: relaxNow,
    link:"https://nwnt.ai/",
    name:"एनडब्ल्यूएनटी",
    type:"web",
    figma:null,
    isSecure:false,
    description:`एनडब्ल्यूएनटी तनाव आ/या जीवनशैली के मुद्दा से पैदा होखे वाली मानसिक,
     भावनात्मक आ व्यवहारिक स्वास्थ्य समस्या सभ के एक-स्टॉप समाधान हवे।`
  },
  {
    src: PathFinder,
    link:"https://path-finder-google-maps.netlify.app/",
    name:"गूगल मैप्स द्वारा पथ खोजक",
    type:"web",
    figma:null,
    isSecure:false,
    description:`इ आपके स्थान से गंतव्य तक के रास्ता खोजे में सक्षम बा।`
  },
  {
    src: pisteyo,
    link:"https://teams.microsoft.com/v2/",
    name:"माइक्रोसॉफ्ट पिस्तेयो ऐप",
    type:"web",
    figma:null,
    isSecure:false,
    description:`पिस्टेयो एगो एआई कंसल्टिंग फर्म हवे जे माइक्रोसॉफ्ट कॉपायलट अपनावे में माहिर
     बा, जवन सिलवावल प्रशिक्षण, वर्कफ़्लो ऑटोमेशन, आ कस्टम जीपीटी चैटबॉट के पेशकश करे
    ले। इनहन के माइक्रोसॉफ्ट टीम्स ऐप (बीटा में) कोपायलट के इस्तेमाल खातिर सकारात्मक 
    आदत आ बेहतरीन तरीका सभ के बढ़ावा देला, उत्पादकता बढ़ावे ला आ वर्कफ़्लो के 
    सुव्यवस्थित करे ला।`
  },
  {
    src: monday,
    link:"https://terdia.monday.com/boards",
    name:"Monday.com इंस्टॉल ऐप सुविधा",
    type:"web",
    figma:null,
    isSecure:false,
    description:`प्रोजेक्ट के प्रगति के संगठित आ ट्रैक करे खातिर मंडे डॉट कॉम के बोर्ड फीचर 
    के लाभ उठावल गइल, जवना से निर्बाध संचार आ कार्य प्रबंधन के सुविधा मिलल, जवना के 
    परिणामस्वरूप टीम के सहयोग आ परियोजना के दक्षता में सुधार भइल.`
  },
  {
    src: talktoenergy,
    link:"https://demo.talktomyenergy.ai",
    name:"ऊर्जा से बात करें",
    type:"web",
    figma:"https://www.figma.com/design/CB5fTEjZvptQ81oe2GiCfh/Mohit_works_21-Apr?node-id=48-2&p=f",
    isSecure:false,
    description:`टॉक टू माई एनर्जी - स्मार्ट एनर्जी इनसाइट्स एंड एआई चैटबॉट टॉक टू माई एनर्जी 
    एगो एडवांस प्लेटफॉर्म ह जवन इंटरएक्टिव चैटबॉट के माध्यम से एआई से चले वाला ऊर्जा इनसाइट्स
     देवेला। ई यूजर लोग के मासिक ग्राफ आ रिपोर्ट के साथ ऊर्जा के खपत के निगरानी आ 
     बिस्लेषण करे में मदद करे ला, ऊर्जा प्रबंधन के सरल आ कुशल बनावे ला। चैटबॉट क्वेरी 
     के जवाब देला, रियल टाइम डेटा देला आ ऊर्जा के इस्तेमाल के अनुकूल बनावे खातिर 
     कार्रवाई करे लायक जानकारी देला।`
  },
  {
    src: highcourt,
    link:"https://punjabharyanahighcourtbar.in",
    name:"पंजाब एवं हरियाणा हाईकोर्ट बार एसोसिएशन",
    type:"web",
    isSecure:false,
    figma:null,
    description:`पंजाब एंड हरियाणा हाई कोर्ट बार एसोसिएशन एगो प्रतिष्ठित कानूनी निकाय ह 
    जवन पंजाब एंड हरियाणा हाई कोर्ट में प्रैक्टिस करे वाला अधिवक्ता लोग के प्रतिनिधित्व करेला।
    न्याय, कानूनी नैतिकता, आ पेशेवर उत्कृष्टता के कायम राखे खातिर प्रतिबद्ध ई संघ न्यायपालिका
    आ कानूनी पेशेवरन के बीच एगो महत्वपूर्ण कड़ी के काम करेला. कानूनी उत्कृष्टता के समृद्ध
    विरासत के साथ, एसोसिएशन कानूनी जागरूकता आ पेशेवर विकास के बढ़ावा देवे खातिर 
    सेमिनार, कार्यशाला, आ आयोजन के आयोजन करेला। एगो मजबूत कानूनी समुदाय के 
    पोषण खातिर समर्पित ई क्षेत्र में न्याय के सुचारू प्रशासन सुनिश्चित करे में अहम भूमिका 
    निभावेला।`
  },
  {
    src: hcba,
    link:"https://hcba.anixinventive.com/",
    name:"हाई कोर्ट बार एसोसिएशन",
    type:"web",
    figma:null,
    isSecure:true,
    description:`पंजाब एंड हरियाणा हाई कोर्ट बार एसोसिएशन एगो प्रतिष्ठित कानूनी निकाय ह 
    जवन पंजाब एंड हरियाणा हाई कोर्ट में प्रैक्टिस करे वाला अधिवक्ता लोग के प्रतिनिधित्व करेला।
    न्याय, कानूनी नैतिकता, आ पेशेवर उत्कृष्टता के कायम राखे खातिर प्रतिबद्ध ई संघ न्यायपालिका
    आ कानूनी पेशेवरन के बीच एगो महत्वपूर्ण कड़ी के काम करेला. कानूनी उत्कृष्टता के समृद्ध
    विरासत के साथ, एसोसिएशन कानूनी जागरूकता आ पेशेवर विकास के बढ़ावा देवे खातिर 
    सेमिनार, कार्यशाला, आ आयोजन के आयोजन करेला। एगो मजबूत कानूनी समुदाय के 
    पोषण खातिर समर्पित ई क्षेत्र में न्याय के सुचारू प्रशासन सुनिश्चित करे में अहम भूमिका 
    निभावेला।`
  },
  {
    src: swing,
    link:"https://opaqueswingers.com/index",
    name:"सर्वश्रेष्ठ स्विंगर डेटिंग ऐप",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`साहसिक जोड़ा आ एकल लोग खातिर बनावल सुरक्षित, सम्मानजनक आ खुला दिमाग 
    वाला जगह में कदम रखीं. चाहे रउआ नया अनुभव के खोज करे के चाहत बानी, समान विचारधारा
    वाला लोग से जुड़ल चाहत बानी, भा अपना जीवनशैली खातिर सही मिलान खोजत बानी, हमनी 
    के ऐप एकरा के आसान बना देला। सत्यापन कइल गइल प्रयोगकर्ता लोग के साथ असली कनेक्शन
    के खोज करीं, सुरक्षित रूप से चैट करीं, आ स्थानीय घटना भा निजी समूह से जुड़ीं। स्मार्ट 
    मिलान, विवेक सुविधा, अवुरी जजमेंट-फ्री समुदाय के संगे आपके अगिला रोमांचक कनेक्शन
    सिर्फ एक स्वाइप दूर बा।`
  },
  {
    src: swingAdmin,
    link:"https://admin.opaqueswingers.com/admin-login",
    name:"अल्टीमेट स्विंगर डेटिंग ऐप एडमिन",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`साहसिक जोड़ा आ एकल लोग खातिर बनावल सुरक्षित, सम्मानजनक आ खुला दिमाग 
    वाला जगह में कदम रखीं. चाहे रउआ नया अनुभव के खोज करे के चाहत बानी, समान विचारधारा
    वाला लोग से जुड़ल चाहत बानी, भा अपना जीवनशैली खातिर सही मिलान खोजत बानी, हमनी 
    के ऐप एकरा के आसान बना देला। सत्यापन कइल गइल प्रयोगकर्ता लोग के साथ असली कनेक्शन
    के खोज करीं, सुरक्षित रूप से चैट करीं, आ स्थानीय घटना भा निजी समूह से जुड़ीं। स्मार्ट 
    मिलान, विवेक सुविधा, अवुरी जजमेंट-फ्री समुदाय के संगे आपके अगिला रोमांचक कनेक्शन
    सिर्फ एक स्वाइप दूर बा।`
  },
  {
    src: GaAdmin,
    link:"https://ga-staging.castledigital.com.au/",
    name:"दुःख ऑस्ट्रेलिया एडमिन",
    type:"web",
    figma:null,
    isSecure:true,
    description:`ग्रिफ ऑस्ट्रेलिया एडमिन पैनल एगो व्यापक बैकएंड मैनेजमेंट सिस्टम हवे जे ग्रिफ 
    ऑस्ट्रेलिया के संचालन के समर्थन करे खातिर बिकसित कइल गइल बा, ई एगो प्रमुख संगठन हवे 
    जे शोक आ शोक सहायता सेवा देवे ला। ई प्लेटफार्म प्रशासक लोग के सुरक्षित, यूजर फ्रेंडली 
    इंटरफेस के माध्यम से यूजर, रिसोर्स, प्रोग्राम, इवेंट आ सामग्री के कुशलता से प्रबंधित करे में
    सक्षम बनावे ला। स्केलेबिलिटी आ इस्तेमाल में आसानी के धियान में रख के डिजाइन कइल गइल
    एडमिन पैनल सामग्री अपडेट, यूजर के अनुमति, डेटा ट्रैकिंग, आ सिस्टम कॉन्फिगरेशन सभ के
    सुव्यवस्थित करे ला ताकि संगठन खातिर रोजमर्रा के कामकाज सुचारू रूप से होखे।`
  },
  {
    src: WhatKeyAdmin,
    link:"https://app.whatkey.io/",
    name:"क्या कुंजी",
    type:"web",
    figma:null,
    isSecure:true,
    description:`व्हाटकी एडमिन पैनल व्हाटकी की मैनेजमेंट प्लेटफार्म के संचालन के प्रबंधन खातिर
     एगो केंद्रीकृत बैकएंड सिस्टम हवे। प्रशासक लोग खातिर बनावल गइल ई पैनल डिजिटल की 
    असाइनमेंट, यूजर एक्सेस लेवल, ऑडिट ट्रेल, आ एसेट ट्रैकिंग पर निर्बाध नियंत्रण के अनुमति
    देला। साफ यूआई आ मजबूत कामकाज के साथ, ई प्रयोगकर्ता लोग के देखरेख, भौतिक आ
    डिजिटल कुंजी सभ के प्रबंधन, आ इस्तेमाल के इतिहास के निगरानी के प्रक्रिया के सरल 
    बनावे ला — संगठन सभ खातिर सुरक्षित आ कुशल कुंजी बितरण सुनिश्चित करे ला।`
  },
  {
    src: ikidzschool,
    link: "https://app.ikidzschools.com/",
    name: "इकिड्स स्कूल के ह",
    type: "web",
    figma: null,
    isSecure: true,
    description: `इकिड्सस्कूल एडमिन पैनल एगो शक्तिशाली आ यूजर फ्रेंडली बैकएंड मैनेजमेंट 
    सिस्टम हवे जे खास तौर पर प्रीस्कूल आ डेकेयर सेंटर खातिर बनावल गइल बा। ई स्कूल प्रशासक
   आ शिक्षाविद लोग के एगो केंद्रीकृत मंच उपलब्ध करावे ला जेह में कई गो केंद्र सभ में रोजाना 
   के कामकाज के आसानी आ परिशुद्धता से प्रबंधन कइल जा सके ला। सही उपस्थिति रिकार्ड 
   बनावे, कक्षा के समय निर्धारित करे, आ पौष्टिक भोजन मेनू के योजना बनावे से ले के
    माता-पिता के साथे रियल-टाइम संवाद आ बच्चा के सुरक्षा खातिर लाइव सीसीटीवी 
    निगरानी के सक्षम बनावे तक — सब कुछ एक ठो सहज डैशबोर्ड में सहज रूप से 
    एकीकृत बा। पैनल शहर, राज्य, कर्मचारी विवरण, आ प्रभारी भूमिका जइसन जरूरी
   डेटा तक जल्दी पहुँच के पेशकश क के कुशल केंद्र-वार प्रबंधन के अनुमति देला।
    एकरे अलावा ई सदस्यता ट्रैकिंग आ बिजनेस इनसाइट्स के सपोर्ट करे ला, जेह से
    प्रशासक लोग के हर सेंटर के परफार्मेंस आ ऑपरेशन के साफ नजारा मिले ला। 
    पैमाना पर बनावल गइल, इकिड्सस्कूल एडमिन पैनल डेटा सुरक्षा, पहुँच नियंत्रण, 
    आ परिचालन पारदर्शिता सुनिश्चित करे ला — शिक्षाविद लोग के सशक्त बनावे ला कि 
    ऊ लोग शुरुआती बचपन के बिकास पर ढेर फोकस करे जबकि बाकी के टेक्नोलॉजी
    संभाले ले। अपना साफ-सुथरा डिजाइन आ मजबूत फीचर के साथ ई स्कूल प्रशासन
    के सरल बनावे ला आ स्टाफ आ अभिभावक दुनों के साथ जुड़ाव बढ़ावे ला, जेकरा 
    चलते ई आधुनिक प्रीस्कूल प्रबंधन खातिर एगो अनिवार्य उपकरण बन गइल बा। `,
  },
  {
    src: hcbaadvocate,
    link: "https://hcbasp.anixinventive.com/",
    name: "Empowering advocates",
    type: "web",
    figma: null,
    isSecure: true,
    description: `पंजाब एंड हरियाणा हाई कोर्ट बार एसोसिएशन एगो विशिष्ट कानूनी संस्थान के
     रूप में खड़ा बा, जवन पंजाब एंड हरियाणा हाई कोर्ट में प्रैक्टिस करे वाला अधिवक्ता लोग के
     प्रतिनिधित्व करेला। न्याय, ईमानदारी, आ कानूनी उत्कृष्टता खातिर अडिग प्रतिबद्धता के साथ,
     एसोसिएशन कानूनी भ्रातृत्व आ न्यायपालिका के बीच सेतु के काम करे ला, पूरा क्षेत्र में न्याय
     के प्रभावी प्रशासन सुनिश्चित करे ला। पारदर्शिता, दक्षता, आ सदस्यन के सुविधा बढ़ावे
     खातिर हमनी का गर्व से एडवोकेट डिजिटल पैनल पेश करत बानी जा, जवन एगो व्यापक 
     वेब आधारित प्लेटफार्म ह जवन कानूनी पेशेवरन के आधुनिक जरूरतन के पूरा करे खातिर 
     बनावल गइल बा.`,
  },
  {
    src: reliefhub,
    link: "https://www.reliefhub.app/login",
    name: "ReliefHub.",
    type: "web",
    figma: "https://www.figma.com/design/XBYc0SkH3YI41rGIRZjd0d/AR-Copy?node-id=334-17637&p=f",
    isSecure: true,
    description: `ReliefHub एगो पूरा आपदा राहत प्रबंधन सिस्टम बा, जवन संगठन, स्वयंसेवक आ प्रभावित घर-मालिक लोग के बीच समन्वय आसान बनावे खातिर तैयार कइल गइल बा।
    ई प्लेटफार्म राहत काम के बीच पूरा प्रक्रिया के एक जगह से सँभारे में मदद करे ला — काम के ऑर्डर ट्रैक करे से लेके टीम से बात करे आ रियल-टाइम रिपोर्ट बनावे तक।
    एह सिस्टम में छह अलग-अलग लॉगिन बानी, जवन हर यूज़र के भूमिका आ जिम्मेदारी के हिसाब से बनावल गइल बा, ताकि जानकारी सुरक्षित रहे आ हर केहू के आपन रोल के हिसाब से सुविधा मिले।`,
  },
  // apps
  {
    src: ga,
    link:"",
    name:"दुःख ऑस्ट्रेलिया",
    type:"apps",
    figma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1729-6926&p=f",
    adminFigma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1047-6597&p=f",
    description:`शोक ऑस्ट्रेलिया एगो अइसन संगठन हवे जे दुख आ नुकसान के अनुभव करे वाला ब्यक्ति आ 
    परिवार सभ खातिर सहायता, शिक्षा आ संसाधन उपलब्ध करावे ला। ई लोग के शोक के नेविगेट करे 
    में मदद करे खातिर काउंसलिंग सेवा, प्रशिक्षण कार्यक्रम, आ शोध के पहल देला। ई संगठन करुणापूर्ण
    देखभाल, सबूत आधारित तरीका, आ समुदाय के समर्थन पर फोकस करे ला जेह से कि ऊ लोग 
    अपना प्रियजन के मौत से निपटे वाला लोग के सहायता कइल जा सके।`
  },
  {
    src: lovelife,
    link:"https://play.google.com/store/apps/details?id=com.sa.lovelife&pli=1",
    name:"प्रेममय जीवन",
    type:"apps",
    figma:"https://drive.google.com/drive/folders/1Ag8DUABP0OKnpaoQEUTtO9o6dwmDV-BK",
    description:`"लव लाइफ" एगो रोमांटिक कॉमेडी-ड्रामा संकलन सीरीज हवे जेकर प्रीमियर 
    एचबीओ मैक्स पर भइल। ई अलग-अलग पात्रन के सफर के अनुसरण करेला जब ऊ लोग समय 
    के साथ प्रेम, रिश्ता, आ व्यक्तिगत विकास के नेविगेट करेला। हर सीजन एगो नया नायक पर
    केंद्रित बा, पहिला प्यार से लेके स्थायी कनेक्शन तक के रोमांस के अनुभव के खोज करेला।
    एह शो में आधुनिक रिश्तन के उतार चढ़ाव के हास्य आ भावनात्मक गहराई से उजागर 
    कइल गइल बा.`
  },
  {
    src: sportsjournal,
    link:"",
    name:"खेल पत्रिका",
    type:"apps",
    figma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=283-463&p=f",
    adminFigma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=0-1&p=f",
    description:`स्पोर्ट्स जर्नल एगो संरचित रिकार्ड हवे जेह में बिबिध खेल आयोजन सभ पर उत्साह,
     बिस्लेषण आ ब्यक्तिगत बिचार सभ के कैप्चर कइल जाला। ई एथलीट, प्रशंसक आ बिस्लेषक लोग 
     खातिर खेल के दुनिया में गेम के हाइलाइट, खिलाड़ी के परफार्मेंस, रणनीति आ रुझान सभ के 
     दस्तावेजीकरण करे खातिर एगो मंच के काम करे ला।`
  },
  {
    src: skin_care,
    link:"",
    name:"त्वचा की देखभाल",
    type:"apps",
    figma:"https://www.figma.com/design/YOllk4yxV6hCJsLqBSA306/UpSkin-Project--Engineer-Preview-?node-id=13-742&p=f",
    description:`ऑल-इन-वन ऐप जवन कि आपके बिना कवनो मेहनत के स्वस्थ, चमकदार त्वचा
    हासिल करे में मदद करे खाती बनावल गईल बा। होम स्क्रीन प आपके जरूरत के मुताबिक
    स्किनकेयर उत्पाद के क्यूरेट सूची के खोज करीं, जवन कि सामग्री, समीक्षा अवुरी विशेषज्ञ
    के सिफारिश के संगे पूरा होई। व्यक्तिगत सलाह, नियमित सुझाव, आ अपना स्किनकेयर
    सवालन के तुरंत जवाब खातिर हमनी के बुद्धिमान एआई संचालित स्किन हेल्पर से 
    चैट करीं। खरीदारी करे से पहिले उत्पाद के विस्तृत जानकारी, सुरक्षा रेटिंग अवुरी 
    उपयोगकर्ता के समीक्षा के जल्दी से उजागर करे खाती बारकोड स्कैनर के इस्तेमाल 
    करीं। अंत में, हमनी के कम्युनिटी स्पेस में समान विचारधारा वाला व्यक्तियन से जुड़ीं,
    जहाँ रउआ अनुभव साझा कर सकेनी, टिप्स ले सकेनी, आ अपना स्किनकेयर यात्रा 
    पर प्रेरित रह सकेनी।`
  },
  {
    src: ikidz_smart_app,
    link: "https://play.google.com/store/apps/details?id=com.chouhan07.ikidz&pcampaignid=web_share",
    name: "इकिड्स स्मार्ट के नाम से जानल जाला",
    type: "apps",
    figma:null,
    description: `IkidzSchool Parent App एगो समर्पित प्लेटफार्म ह जवन 
    अभिभावकन के अपना बच्चा के प्रीस्कूल यात्रा से सक्रिय रूप से जुड़ल राखे खातिर 
    बनावल गइल बा. सुरक्षित लॉगिन पहुँच के साथ, माता-पिता बिना कवनो मेहनत के
     रियल टाइम हाजिरी रिकॉर्ड देख सकेलें ताकि अपना बच्चा के रोजाना के मौजूदगी 
    के बारे में जानकारी मिल सके। ए ऐप में इंटीग्रेटेड लाइव सीसीटीवी स्ट्रीमिंग भी बा,
    जवना से अभिभावक कक्षा अवुरी गतिविधि के समय में अपना छोट बच्चा के देख 
    सकतारे — जवना से मन के शांति अवुरी पारदर्शिता सुनिश्चित होई। घर अवुरी स्कूल
    के बीच संवाद के अंतर के दूर क के इ ऐप भरोसा अवुरी भागीदारी के बढ़ावा देवेला, 
    जवना से अभिभावक के अपना बच्चा के शुरुआती सीखला के अनुभव खाती आगे के 
    पंक्ति के सीट मिलता। सरल, सुरक्षित, आ विश्वसनीय — IkidzSchool Parent App
   आधुनिक, सूचित पेरेंटिंग खातिर एगो जरूरी उपकरण बा। `,
  },
  {
    src: hcba_app,
    link: "https://play.google.com/store/apps/details?id=com.advocate.hcba",
    name: "एचसीबीए-सीएचडी के बा",
    type: "apps",
    figma:null,
    description: `पंजाब आ हरियाणा हाई कोर्ट बास एसोसिएशन चंडीगढ़ मोबाइल ऐप अपना 
    रजिस्टर्ड यूजर के आपन प्रोफाइल ऑनलाइन एक्सेस आ मैनेज करे में सक्षम बनावेला.पंजाब 
    आ हरियाणा हाई कोर्ट बास एसोसिएशन चंडीगढ़ मोबाइल ऐप अपना रजिस्टर्ड यूजर के आपन 
    प्रोफाइल ऑनलाइन एक्सेस आ मैनेज करे में सक्षम बनावेला. एहसे यूजर अपना साथी एडवोकेट
     के खोज सकेलें, भुगतान के इतिहास देख सकेलें आ कानूनी वेबसाइटन के जल्दी से संदर्भ दे
     सकेलें.`,
  },
  {
    src: rewind,
    link: "https://play.google.com/store/apps/details?id=com.ianix.rewind",
    name: "Rewind",
    type: "apps",
    figma:null,
    description: `अंतरात्मा एगो AI-संचालित सोच-समझ आ मन के शांति देवे वाला ऐप बा, जवन यूज़र के
     आपन भीतरी मन से जुड़ेला मदद करे ला। एह में आवाज़ आ लिखल बात के सहारे बात हो सकेला। ई ऐप
      Gemini AI के सहारे नैचुरल लैंग्वेज प्रोसेसिंग आ भावनात्मक समझ के ताकत के जोड़ के, एगो शांति भरा
       आ निजी अनुभव देवे ला। यूज़र आपन दिल के बात बोल सकत बाड़ें, ऐप में बनल speech recognition 
       फीचर से। AI (अंतरात्मा) ध्यान से सुनेला, समझेला, आ सहानुभूति से जवाब देला — जवन एगो सुरक्षित
       डिजिटल जगह बनावेला जिथे आदमी आपन भावना खुल के बयां कर सके आ आपन आत्मा के समझ सके।`,
  },

]

const education =(
  <>
    <b>चंडीगढ़ इंजीनियरिंग कॉलेज से सूचना प्रौद्योगिकी में बीटेक</b> से स्नातक भइल हमरा लगे सॉफ्टवेयर डेवलपमेंट आ इंजीनियरिंग सिद्धांत में मजबूत नींव बा, फुल स्टैक वेब डेवलपमेंट आ अत्याधुनिक टेक्नोलॉजी में हाथ से अनुभव बा.
  </>
)

// Top / sidebar Link
const links = [
  {
    name: "Home",
    route: "/",
  },
  {
    name: "About",
    route: "about",
  },
  {
    name: "Services",
    route: "services",
  },
  {
    name: "Projects",
    route: "projects",
  },
  {
    name: "Contact",
    route: "contact",
  },
];


const Constant = {
  about,detailAbout,
  technologies_tools,projects
  ,education,Profile_Photo,
  heroBg,cloud,cloudDark,
  shortIntro,techStack,
  contactLinks,links,serviceData
};
export default Constant;
